/* Sticky mobile checkout bar for the cart page.

   The bar shows once the real Check out button has scrolled out of view and
   hides again when it returns, so the two are never on screen together.

   Elements are re-queried on every frame rather than cached, because cart.js
   replaces the whole .js-contents block (bar included) after each quantity
   change — cached references would go stale. Reading layout in a rAF-throttled
   scroll handler keeps that cheap. */
(function () {
  var BREAKPOINT = 750;
  var ticking = false;

  function update() {
    ticking = false;
    var bar = document.querySelector('[data-uw-cart-bar]');
    if (!bar) return;

    var btn = bar.querySelector('.uw-cart-bar__btn');
    var mainCheckout = document.querySelector('.cart__checkout-button');

    // Desktop, or no cart form on the page: keep it out of the way entirely.
    if (window.innerWidth >= BREAKPOINT || !mainCheckout) {
      setVisible(bar, btn, false);
      return;
    }

    var rect = mainCheckout.getBoundingClientRect();
    // "Out of view" = scrolled past the top, or still below the fold.
    var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    setVisible(bar, btn, outOfView);
  }

  function setVisible(bar, btn, visible) {
    if (visible === !bar.hasAttribute('hidden')) return; // no change
    if (visible) {
      bar.removeAttribute('hidden');
      bar.classList.add('is-visible');
      if (btn) btn.removeAttribute('tabindex');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('hidden', '');
      if (btn) btn.setAttribute('tabindex', '-1');
    }
  }

  /* Throttled with a timer rather than requestAnimationFrame: rAF is suspended
     whenever the page isn't being painted (background tab, some embedded
     webviews), which would leave the bar stuck in its last state. */
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.setTimeout(update, 16);
  }

  function init() {
    if (!document.body.classList.contains('template-cart')) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // cart.js re-renders the footer; re-evaluate once the new DOM settles.
    var footer = document.getElementById('main-cart-footer');
    if (footer && window.MutationObserver) {
      new MutationObserver(onScroll).observe(footer, { childList: true, subtree: true });
    }
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
